import request from '../../../api/request';
import { StudentStudyPlansResponse } from '../parts/studyPlans/types';

const STUDY_PLANS = {
  GET_STUDY_PLANS: (studentId: string | number) =>
    `maintainers-portal/student-management/student-study-plans/${studentId}`,
};

export function getStudentStudyPlans(studentId: number) {
  return request<StudentStudyPlansResponse>(
    STUDY_PLANS.GET_STUDY_PLANS(studentId),
  );
}
